import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import CII2014Icon from '../../../../assets/awards/CII2014.svg';
import CII2017Icon from '../../../../assets/awards/CII2017.svg';
import IDM2017Icon from '../../../../assets/awards/IDM2017.svg';

const AwardData = {
	id: 8,
	widgetName: 'Award Winning Widget',
	inherentType: 'WIDGET',
	template: {
		type: 'AWARD_WINNING',
		headers: {
			textContent: [
				{
					typeScale: 'H6_Medium',
					text: 'Designed By',
					color: 'Gray 0',
				},
				{
					typeScale: 'H14_Regular',
					text: 'an Award winning team',
					color: 'Gray -2',
				},
			],
		},
	},
	components: [
		{
			type: 'Photo_Below_Text',
			inherentType: 'COMPONENT',
			data: {
				AwardsData: [
					{
						icon: {
							url: 'https://picsum.photos/93/99',
							aspectRatio: 0.93,
						},
						textContent: {
							text: 'CII Design Excellence Award, 2014',
							typeScale: 'Small_Regular',
							color: 'Gray -3',
						},
						imageIcon: <CII2014Icon />,
					},
					{
						icon: {
							url: 'https://picsum.photos/93/99',
							aspectRatio: 0.93,
						},
						textContent: {
							text: 'CII Design Excellence Award, 2017',
							typeScale: 'Small_Regular',
							color: 'Gray -3',
						},
						imageIcon: <CII2017Icon />,
					},
					{
						icon: {
							url: 'https://picsum.photos/93/99',
							aspectRatio: 0.93,
						},
						textContent: {
							text: 'India Design Mark, 2017',
							typeScale: 'Small_Regular',
							color: 'Gray -3',
						},
						imageIcon: <IDM2017Icon />,
					},
				],
				AwardsDataDefinition: {
					textContent: {
						text: 'Furlenco`s furniture is designed by our incredibly talented team of designers. Every design journey is guided by our passion to create user insight driven, unique and high quality products that provide our customers a delightful experience. Our furniture has been awarded the CII Design Excellence Award in 2014 and 2017 as well as the India Design Mark in 2017 and 2018.',
						typeScale: 'H14_Regular',
						color: 'Gray -1',
					},
				},
			},
		},
	],
};

type AwardProps = {
	awards: string[];
};
const AwardInformationComponent = (props: AwardProps) => {
	return (
		<FlexBox sx={{ width: '100%' }}>
			<FlexBox direction='column'>
				{AwardData.template.headers.textContent.map((text, index) => {
					return (
						<LencoTypography
							sx={{
								...getStyle(text.typeScale),
								color: getColor(text.color),
							}}
							key={index}
						>
							{text.text}
						</LencoTypography>
					);
				})}
				<FlexBox sx={{ paddingTop: '24px' }}>
					{AwardData.components[0].data.AwardsData.map((Awards, index) => {
						return (
							<Box sx={{ paddingRight: '8px' }} key={index}>
								{Awards.imageIcon}
								<LencoTypography
									sx={{
										...getStyle(Awards.textContent.typeScale),
										color: getColor(Awards.textContent.color),
									}}
								>
									{Awards.textContent.text}
								</LencoTypography>
							</Box>
						);
					})}
				</FlexBox>
			</FlexBox>

			<FlexBox sx={{ paddingLeft: '80px', paddingTop: '24px' }}>
				<LencoTypography
					sx={{
						...getStyle(
							AwardData.components[0].data.AwardsDataDefinition.textContent
								.typeScale
						),
						color: getColor(
							AwardData.components[0].data.AwardsDataDefinition.textContent
								.color
						),
					}}
				>
					{AwardData.components[0].data.AwardsDataDefinition.textContent.text}
				</LencoTypography>
			</FlexBox>
		</FlexBox>
	);
};

export default AwardInformationComponent;
